import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import _ from 'lodash';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { PanelModule } from 'primeng/panel';
import { ModalComponent } from '../../shared/modal/modal.component';
import { CustomFormControl } from '../../shared/shared.model';
import { MultiSelectModule } from 'primeng/multiselect';

@Component({
  selector: 'app-subpoena',
  imports: [InputTextModule,CommonModule, ButtonModule, SelectModule, ReactiveFormsModule,DropdownModule, PanelModule, ModalComponent, MultiSelectModule],
  templateUrl: './subpoena.component.html',
  styleUrl: './subpoena.component.scss'
})
export class SubpoenaComponent {
  @Input() subjects: any;
  @Input() formData: any;
  @Input() states: any;
  @Output() formChanged = new EventEmitter<void>();
  formGroup!: FormGroup;
  subjectNames: any [] = [];
  showDeleteModal: boolean = false;
  itemToDelete: any;
  deleteType: any;

  ngOnInit(): void {
    if(this.subjects) {
      let nameList = _.map(_.get(this.subjects, 'subjects'),item => ({ name: item.recordSubjectName, value: item.recordSubjectName }));
      if(nameList && !_.isNull(nameList[0])) {
        this.subjectNames = nameList;
      }
      
    }
    this.formGroup = new FormGroup({
      'opposingCounseals': new FormArray([this.createOpposingCounsealFormGroup()]),
      'defendants': new FormArray([this.createDefendantFormGroup()]),
      'judge': new FormControl(null),
      'court': new CustomFormControl(null, 'Court', [Validators.required]),
      'courtStreetAddress': new FormControl(null),
      'jurisdictionCounty': new CustomFormControl(null, 'Jurisdiction County', [Validators.required]),
      'state': new FormControl(null),
      'cityName': new FormControl(null),
      'zipCode': new FormControl(null),
      'caseNumber': new CustomFormControl(null, 'Case number', [Validators.required])
    }); 

    if(this.formData) {
      this.initializeFormData();
    }
    
    this.formGroup.valueChanges.subscribe(()=>{
      this.formChanged.emit();
    });
    
  }


  /**
   * Gets the opposingCounseal form array.
   * @returns The FormArray of opposingCounseal.
   */
  get opposingCounseals(): FormArray {
    return this.formGroup.get('opposingCounseals') as FormArray;
  }

  /**
   * Adds a new opposingCounseal to the opposingCounseal form array.
   */
  addOpposingCounseal(): void {  
    this.opposingCounseals.push(this.createOpposingCounsealFormGroup());
  }

  /**
   * Removes a opposingCounseal from the opposingCounseal form array.
   * @param index The index of the opposingCounseal to remove.
   */
  removeOpposingCounseal(index: number) {
    // this.opposingCounseals.removeAt(index);
    this.showDeleteModal = true;
    this.itemToDelete = index;
    this.deleteType = 'opposingCounseal';
  }

  createOpposingCounsealFormGroup(item?: any): FormGroup {
    return new FormGroup({
      'recordSubjectName': new CustomFormControl((item && item?.recordSubjectName?.length > 0) ? item?.recordSubjectName : (this.subjectNames.length == 1 ? this.subjectNames : null), 'Record Subject Name', [Validators.required]),
      'opposingCounselAttorneyName': new CustomFormControl(item ? item?.opposingCounselAttorneyName : null, 'Opposing Counsel Attorney Name', [Validators.required]),
      'opposingCounselFirmName': new CustomFormControl(item ? item?.opposingCounselFirmName : null, 'Opposing Counsel Firm Name', [Validators.required]),
      'streetAddress': new FormControl(item ? item?.streetAddress : null),
      'city': new FormControl(item ? item?.city : null),
      'state': new FormControl(item ? item?.state : null),
      'zip': new FormControl(item ? item?.zip : null),
      'phone': new FormControl(item ? item?.phone : null),
      'extn': new FormControl(item ? item?.extn : null),
      'fax': new FormControl(item ? item?.fax : null),
      'email': new FormControl(item ? item?.email : null, Validators.email)
    });
  }


  /**
   * Gets the defendant form array.
   * @returns The FormArray of defendant.
   */
  get defendants(): FormArray {
    return this.formGroup.get('defendants') as FormArray;
  }

  /**
   * Adds a new defendant to the defendant form array.
   */
  addDefendant(): void {  
    this.defendants.push(this.createDefendantFormGroup());
  }

  /**
   * Removes a defendant from the defendant form array.
   * @param index The index of the defendant to remove.
   */
  removeDefendant(index: number) {
    // this.defendants.removeAt(index);
    this.showDeleteModal = true;
    this.itemToDelete = index;
    this.deleteType = 'defendant';
  }

  createDefendantFormGroup(item?:any): FormGroup {
    return new FormGroup({
      'name': new CustomFormControl(item ? item?.name : null, 'Defendant Name', [Validators.required]),
      'streetAddress': new FormControl(item ? item?.streetAddress : null),
      'city': new FormControl(item ? item?.city : null),
      'state': new FormControl(item ? item?.state : null),
      'zip': new FormControl(item ? item?.zip : null)
    });
  }
  /**
  * Highlights a control for validation.
  */
  isError(controlId: any, control?:any) {
    let formControl = this.formGroup.get(controlId);
    if(!formControl)
      formControl = control.get(controlId);
    return formControl ? (formControl.invalid && (formControl.dirty || formControl.touched)) : false;
  }

  delete() {
    if(this.itemToDelete >= 0) {
      switch(this.deleteType) {
        case 'defendant':
          this.defendants.removeAt(this.itemToDelete);
          break;
        case 'opposingCounseal':
          this.opposingCounseals.removeAt(this.itemToDelete);
      }
      this.itemToDelete = null;
      this.showDeleteModal = false;
      this.deleteType = '';
    }
    
  }


  initializeFormData() {
    if (this.formData?.defendants) {
      this.defendants.clear();
      _.forEach(this.formData.defendants, defendant => {
        this.defendants.push(this.createDefendantFormGroup(defendant));
      })
    }

    if (this.formData?.opposingCounseals) {
      this.opposingCounseals.clear();
      _.forEach(this.formData.opposingCounseals, opposingCounseal => {
        this.opposingCounseals.push(this.createOpposingCounsealFormGroup(opposingCounseal));
      })
    }

    this.formGroup.patchValue({
      judge: this.formData.judge,
      court: this.formData.court,
      courtStreetAddress: this.formData.courtStreetAddress,
      jurisdictionCounty: this.formData.jurisdictionCounty,
      state: this.formData.state,
      cityName: this.formData.cityName,
      zipCode: this.formData.zipCode,
      caseNumber: this.formData.caseNumber
    })

  }

}
